import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
type PlanKey = 'esencial' | 'completo';
export function Purchase() {
  const [selected, setSelected] = useState<PlanKey>('completo');
  const plans: Record<PlanKey, {
    label: string;
    cta: string;
  }> = {
    esencial: {
      label: 'SÍ, QUIERO EL MEGAKIT ESENCIAL →',
      cta: 'https://capilaradn.ebookditales.com/cart/45049967804495:1'
    },
    completo: {
      label: 'SÍ, QUIERO EL MEGAKIT COMPLETO →',
      cta: 'https://capilaradn.ebookditales.com/cart/45049987956815:1'
    }
  };
  return <section id="compra" className="py-16 md:py-24 px-4 bg-gray-50 border-t border-gray-200 relative" data-id="element-128">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(34,197,94,0.03)_0%,transparent_70%)] pointer-events-none" data-id="element-129"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-130">
        {/* Emotional copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-131">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8" data-id="element-132">
            EL MOMENTO DE DECIDIR
          </h2>
          <div className="space-y-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-133">
            <p data-id="element-134">
              Hay dos tipos de pibes: el que sigue scrolleando y el que dice{' '}
              <strong className="text-gray-900" data-id="element-135">"no me resigno"</strong> y da el
              paso.
            </p>
            <p className="font-bold text-gray-900 text-xl mt-4" data-id="element-136">
              El Sistema Megakit está listo. Lo único que falta sos vos.
            </p>
          </div>
        </motion.div>

        {/* Pricing selector - fits one iPhone screen */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="min-h-[100dvh] flex flex-col justify-center md:min-h-0" data-id="element-137">
          <div className="text-center mb-4 md:mb-10" data-id="element-138">
            <h2 className="text-2xl md:text-5xl font-bold text-gray-900" data-id="element-139">
              Elegí tu <span className="text-gold" data-id="element-140">MEGAKIT:</span>
            </h2>
            <p className="text-gray-500 mt-1 md:mt-3 text-sm md:text-lg" data-id="element-141">
              Todas las opciones incluyen los 5 bonos estratégicos
            </p>
          </div>

          <div className="space-y-3 md:space-y-4 max-w-2xl mx-auto mb-4 md:mb-8 w-full" data-id="element-142">
            {/* Option 1: Esencial */}
            <button onClick={() => setSelected('esencial')} className={`w-full text-left rounded-xl p-3.5 md:p-6 border-2 transition-all duration-300 flex items-center gap-3 md:gap-4 ${selected === 'esencial' ? 'border-gold bg-white shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border-gray-200 bg-white/50 hover:border-gray-300'}`} data-id="element-143">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${selected === 'esencial' ? 'border-gold' : 'border-gray-300'}`} data-id="element-144">
                {selected === 'esencial' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-gold" data-id="element-145"></div>}
              </div>

              <div className="flex-grow min-w-0" data-id="element-146">
                <div className="flex items-center gap-1.5 md:gap-2" data-id="element-147">
                  <span className="text-base md:text-lg" data-id="element-148">📚</span>
                  <h3 className="font-heading font-bold text-base md:text-2xl text-gray-900 uppercase" data-id="element-149">
                    MEGAKIT ESENCIAL
                  </h3>
                </div>
                <p className="text-gray-500 text-xs md:text-sm" data-id="element-150">
                  6 Tomos + 5 Bonos GRATIS
                </p>
              </div>

              <div className="text-right shrink-0" data-id="element-151">
                <p className="text-gray-400 line-through text-xs md:text-sm" data-id="element-152">
                  $45.000
                </p>
                <p className={`text-xl md:text-3xl font-bold ${selected === 'esencial' ? 'text-gold' : 'text-gray-900'}`} data-id="element-153">
                  $19.990
                </p>
              </div>
            </button>

            {/* Option 2: Completo */}
            <button onClick={() => setSelected('completo')} className={`w-full text-left rounded-xl p-3.5 md:p-6 border-2 transition-all duration-300 flex items-center gap-3 md:gap-4 ${selected === 'completo' ? 'border-gold bg-white shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border-gray-200 bg-white/50 hover:border-gray-300'}`} data-id="element-154">
              <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${selected === 'completo' ? 'border-gold' : 'border-gray-300'}`} data-id="element-155">
                {selected === 'completo' && <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-gold" data-id="element-156"></div>}
              </div>

              <div className="flex-grow min-w-0" data-id="element-157">
                <div className="flex items-center gap-1.5 md:gap-2" data-id="element-158">
                  <span className="text-base md:text-lg" data-id="element-159">🏆</span>
                  <h3 className="font-heading font-bold text-base md:text-2xl text-gray-900 uppercase" data-id="element-160">
                    MEGAKIT COMPLETO
                  </h3>
                </div>
                <span className="inline-block bg-gold text-white text-[10px] md:text-xs font-bold px-1.5 py-0.5 rounded" data-id="element-161">
                  ⭐ MÁS ELEGIDO
                </span>
                <p className="text-gray-500 text-xs md:text-sm" data-id="element-162">
                  6 Tomos + 5 Bonos + 3 Protocolos Extra
                </p>
              </div>

              <div className="text-right shrink-0" data-id="element-163">
                <p className="text-gray-400 line-through text-xs md:text-sm" data-id="element-164">
                  $99.990
                </p>
                <p className={`text-xl md:text-3xl font-bold ${selected === 'completo' ? 'text-gold' : 'text-gray-900'}`} data-id="element-165">
                  $29.990
                </p>
              </div>
            </button>
          </div>

          {/* CTA */}
          <div className="text-center max-w-2xl mx-auto w-full" data-id="element-166">
            <CTAButton href={plans[selected].cta} className="w-full text-base md:text-2xl py-4 md:py-5" data-id="element-167">
              {plans[selected].label}
            </CTAButton>

            <p className="text-gray-500 text-xs md:text-sm mt-2 md:mt-3 italic" data-id="element-168">
              Podés cambiar de opción cuando quieras
            </p>

            <div className="mt-2 md:mt-4 flex items-center justify-center gap-4 text-gray-500 text-xs md:text-sm" data-id="element-169">
              <span data-id="element-170">🔒 Pago 100% Seguro</span>
              <span data-id="element-171">⚡ Acceso Inmediato</span>
            </div>
          </div>

          {/* Details of selected plan */}
          <motion.div key={selected} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3
        }} className="max-w-2xl mx-auto mt-4 md:mt-6 bg-white border border-gray-200 rounded-xl p-4 md:p-8 w-full shadow-sm" data-id="element-172">
            <h3 className="font-heading font-bold text-xl text-gray-500 uppercase mb-6" data-id="element-173">
              {selected === 'esencial' ? 'MEGAKIT ESENCIAL INCLUYE:' : 'MEGAKIT COMPLETO INCLUYE:'}
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm md:text-base" data-id="element-174">
              <div className="flex items-start gap-2 text-gray-600" data-id="element-175">
                <span className="text-green-500 shrink-0" data-id="element-176">✓</span>
                <span data-id="element-177">6 Tomos completos</span>
              </div>
              <div className="flex items-start gap-2 text-gray-600" data-id="element-178">
                <span className="text-green-500 shrink-0" data-id="element-179">✓</span>
                <span data-id="element-180">+15 recetas de tónicos</span>
              </div>
              <div className="flex items-start gap-2 text-gray-600" data-id="element-181">
                <span className="text-green-500 shrink-0" data-id="element-182">✓</span>
                <span data-id="element-183">5 Bonos estratégicos</span>
              </div>
              <div className="flex items-start gap-2 text-gray-600" data-id="element-184">
                <span className="text-green-500 shrink-0" data-id="element-185">✓</span>
                <span data-id="element-186">Calendario de Guerra Capilar</span>
              </div>
              <div className="flex items-start gap-2 text-gray-600" data-id="element-187">
                <span className="text-green-500 shrink-0" data-id="element-188">✓</span>
                <span data-id="element-189">Acceso inmediato digital</span>
              </div>
              <div className="flex items-start gap-2 text-gray-600" data-id="element-190">
                <span className="text-green-500 shrink-0" data-id="element-191">✓</span>
                <span data-id="element-192">Formato PDF descargable</span>
              </div>
            </div>

            {selected === 'completo' && <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-193">
                <p className="text-gold font-heading font-bold text-lg uppercase mb-4" data-id="element-194">
                  + 3 Protocolos Extra Exclusivos:
                </p>
                <div className="space-y-5" data-id="element-195">
                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-196">
                    <div className="flex items-start gap-3" data-id="element-197">
                      <span className="text-2xl shrink-0" data-id="element-198">🚀</span>
                      <div data-id="element-199">
                        <h4 className="font-bold text-gray-900 text-base mb-1" data-id="element-200">
                          "EL ESCUDO ANTI-FLASH"
                        </h4>
                        <p className="text-gray-500 text-sm leading-relaxed" data-id="element-201">
                          ¿Te da pánico que te saquen una foto de arriba y la
                          pelada brille como un espejo? Con este método vas a
                          aprender el hack del Almidón Orgánico para engrosar el
                          pelo visualmente en 2 minutos y el Mate Capilar para
                          oscurecer el cuero cabelludo y eliminar el contraste.
                          Dejá de brillar bajo las luces del boliche o la
                          oficina mientras el Megakit hace nacer tu pelo nuevo.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-202">
                    <div className="flex items-start gap-3" data-id="element-203">
                      <span className="text-2xl shrink-0" data-id="element-204">🛌</span>
                      <div data-id="element-205">
                        <h4 className="font-bold text-gray-900 text-base mb-1" data-id="element-206">
                          "PARANOIA CERO: Protocolo de la Almohada"
                        </h4>
                        <p className="text-gray-500 text-sm leading-relaxed" data-id="element-207">
                          No hay nada peor que arrancar el día contando cuántos
                          pelos se te cayeron anoche. Con este protocolo vas a
                          blindar tu pelo mientras dormís: aprendé la técnica
                          del Tónico de Anclaje, el secreto de la funda de satén
                          para eliminar la fricción que te arranca el pelo y
                          cómo bajar el cortisol nocturno para que tu cuerpo
                          fabrique pelo mientras descansás. Dormí tranquilo, tu
                          pelo ahora está seguro.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-208">
                    <div className="flex items-start gap-3" data-id="element-209">
                      <span className="text-2xl shrink-0" data-id="element-210">🚿</span>
                      <div data-id="element-211">
                        <h4 className="font-bold text-gray-900 text-base mb-1" data-id="element-212">
                          "FILTRO QUÍMICO CASERO"
                        </h4>
                        <p className="text-gray-500 text-sm leading-relaxed" data-id="element-213">
                          ¿Sabías que el cloro y el sarro de tu ducha destruyen
                          los activos del romero y la ortiga en segundos? No
                          dejes que el agua dura tape tus folículos otra vez. Te
                          enseño a fabricar un Spray Neutralizador de Vitamina C
                          que elimina el cloro al contacto y un Enjuague
                          Desmineralizante para barrer el sarro. Asegurá que
                          cada gota de tónico que uses penetre al 100% sin
                          interferencias químicas.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </motion.div>
        </motion.div>

        <div className="mt-16 text-center text-xs text-gray-500 max-w-3xl mx-auto leading-relaxed" data-id="element-214">
          <p data-id="element-215">
            Este sistema es de uso exclusivo del comprador. El autor no es
            médico ni profesional de la salud. El contenido es de carácter
            informativo y cosmético. Realizá siempre el Test de la Muñeca antes
            de aplicar cualquier ingrediente nuevo. Si tenés condiciones médicas
            preexistentes, consultá a tu médico antes de empezar.
          </p>
        </div>
      </div>
    </section>;
}